import React from 'react';
import './Teaching.css';

function Teaching() {
  return (
    	<div className='Teaching'>
    		<p className='heading1'>A really good explanation of my teaching agenda.</p>
      </div>
  );
}

export default Teaching;